import type {
  InventorySystemProfileDTO,
  SelectOption,
  TenantDTO,
  VenueDTO,
} from '../../../types'

// Map the tenant/ISP/venue lists into dropdown options for the config filter
// bar. Each option's value is the field the API filters on (tenant code, ISP
// code, venue id); labels mirror the create-config form. Sorted by label so the
// dropdown order is stable.
export function buildConfigFilterOptions(
  tenants: TenantDTO[],
  profiles: InventorySystemProfileDTO[],
  venues: VenueDTO[]
): {
  tenantOptions: SelectOption[]
  ispOptions: SelectOption[]
  venueOptions: SelectOption[]
} {
  return {
    tenantOptions: tenants
      .map((t) => ({ value: t.code, label: `${t.code} (ID: ${t.id})` }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    ispOptions: profiles
      .map((p) => ({ value: p.code, label: `${p.code} (ID: ${p.id})` }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    venueOptions: venues
      .map((v) => ({ value: v.id, label: `${v.venueSlug} (ID: ${v.id})` }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  }
}
